import { cn } from "@/utils/cn";
import { PaginationProps } from "./Pagination.types";
import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon, ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components/atoms/Button";
export const Pagination = ({
    page,
    totalPages,
    onPageChange,
    className,
    showEdges = false,
    maxPages = 3,
}: PaginationProps) => {
    if (totalPages <= 1) return null;

    const half = Math.floor(maxPages / 2);

    let start = Math.max(1, page - half);
    let end = Math.min(totalPages, start + maxPages - 1);
    if (end - start < maxPages - 1) {
        start = Math.max(1, end - maxPages + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    return (
        <div className={cn("flex justify-center items-center gap-1", className)}>
            {showEdges && page > 1 && (
                <Button
                    size="xs"
                    variant="outline"
                    onClick={() => onPageChange(1)}
                >
                    <ChevronDoubleLeftIcon className="h-4 w-4" aria-hidden="true" />
                </Button>
            )}

            {page > 1 && (
                <Button
                    size="xs"
                    variant="outline"
                    onClick={() => onPageChange(page - 1)}
                >
                    <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" />
                </Button>
            )}

            {pages.map((p) => (
                <Button
                    key={p}
                    size="xs"
                    variant={p === page ? "primary" : "secondary"}
                    onClick={() => onPageChange(p)}
                >
                    {p}
                </Button>
            ))}

            {page < totalPages && (
                <Button
                    size="xs"
                    variant="outline"
                    onClick={() => onPageChange(page + 1)}
                >
                    <ChevronRightIcon className="h-4 w-4" aria-hidden="true" />
                </Button>
            )}

            {showEdges && page < totalPages && (
                <Button
                    size="xs"
                    variant="outline"
                    onClick={() => onPageChange(totalPages)}
                >
                    <ChevronDoubleRightIcon className="h-4 w-4" aria-hidden="true" />
                </Button>
            )}
        </div>
    );
};
